// extracted by mini-css-extract-plugin
export default {"container":"Table_container__Y8UaH"};